import { render, staticRenderFns } from "./SectionItemSameCategory.vue?vue&type=template&id=eabb2e76&lang=pug&"
import script from "./SectionItemSameCategory.vue?vue&type=script&lang=js&"
export * from "./SectionItemSameCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports